// src/tokens/borderRadius.ts
var borderRadius01 = "2px";
var borderRadius02 = "4px";
var borderRadius04 = "8px";
var borderRadiusPill = "16px";
export { borderRadius01, borderRadius02, borderRadius04, borderRadiusPill };